<!-- <div class="help-text">
  <app-help-icon [clickAction]="showHelp"></app-help-icon>
</div> -->
<app-textarea-input *ngIf="!useHtml" [showWordCount]="false"
  [rows]="isInModal ? 10 : 4" [autoGrow]="true" placeholder="Type content here" [required]="false" [name]="name" [label]="label"
  [(ngModel)]="value" style="min-width:300px;" [maxWidth]="isInModal ? '100%' : ''" [maxLength]="maxLength"
  (ionChange)="onValueChange()">
</app-textarea-input>

<div class="froala-div" *ngIf="useHtml && showFroala">
  <ion-label *ngIf="label">{{label}}</ion-label>
  <div #froala [froalaEditor]="froalaOptions" [(froalaModel)]="value" (froalaModelChange)="onValueChange()" class="wysiwyg-editor"
    (froalaInit)="initializeFroala($event)"></div>
</div>

<div class="flex-c" *ngIf="!htmlOnly">
  <span>Use Html Editor:</span><ion-toggle [(ngModel)]="useHtml"></ion-toggle>
</div>

<ion-button *ngIf="!isInModal && allowLargeEditor" (click)="openHtmlEditor()">Open Large Editor</ion-button>